import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SelectDateFilterWithDropdown from 'modules/common/components/SelectDateFilterWithDropdown';
import Loading from 'modules/common/components/Loading';
import RptChartComponent from '../components/RptChartComponent';
import withDashboard from '../../../common/hoc/withDashboard';

import * as c from '../constant';
import * as actions from '../action';

const renderLegends = (dt) =>
  dt.map((x) => {
    return (
      <div key={x.name} className="legend-item">
        <div
          style={{
            background: `${x.color}`,
            width: 20,
            height: 20,
            marginRight: 20,
          }}
        />
        <div className="legend-text">{x.name}</div>
      </div>
    );
  });
function DashboardChartMapContainer({
  getGraphStats,
  datedCounts,
  // createDynamicAreaChart,
}) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    getGraphStats();
  }, []);

  const handleOnSubmit = (data) => {
    getGraphStats(data);
  };

  return (
    <div className="stat">
      <div className="stat-filters">
        <SelectDateFilterWithDropdown onSubmit={handleOnSubmit} />
      </div>
      {isLoading && <Loading />}
      <RptChartComponent chartData={datedCounts} />
      <div className="legends-wrapper area px-3 w-100">
        <div
          className="render-chart-legends"
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            flexWrap: 'wrap',
          }}
        >
          {renderLegends(c.STATISTICS)}
        </div>
      </div>
    </div>
  );
}

DashboardChartMapContainer.propTypes = {
  // createDynamicAreaChart: PropTypes.instanceOf(Function).isRequired,
  // // realTimeTransaction: PropTypes.instanceOf(Array).isRequired,
  getGraphStats: PropTypes.instanceOf(Function).isRequired,
  datedCounts: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  datedCounts: _.get(api, `${c.GET_GRAPH_STATS}.list`) || [],
});

const enhance = _.flowRight([
  withDashboard,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(DashboardChartMapContainer);
